module.exports = __webpack_public_path__ + "static/media/_MIC2705.thumbnail.33281947.png";